/**
 * event-menu-item.js
 */

import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { format, parseISO, isAfter } from 'date-fns';
import { Types } from 'utils/constants';
import useRecordStore from 'contexts/record-store';
import DrawerMenuItem from 'components/menu-drawer/menu/drawer-menu-item';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: theme.typography.sizes[1],
  },
  sub: {
    fontSize: theme.typography.sizes[1]
  },
}));

export default function EventMenuItem(props) {
  const {
    id,
    record,
    to,
    isActive,
    hideChevron
  } = props;
  const classes = useStyles();
  const recordStore = useRecordStore();
  const eventItem = recordStore.useRecord(Types.Record.EVENT, id).ornull;
  const eventRecord = record ? record : eventItem ? eventItem.get() : null;

  const chip = (eventItem) => {
    if (!eventItem.exercises) return null;

    let label = '';
    let className = '';
    const isFuture = isAfter(parseISO(eventItem.date), new Date());
    const hasNoExers = eventItem.exercises.length === 0;

    if (isFuture && hasNoExers) {
      label = 'Scheduled';
      className = 'chip-upcoming chip-font-upcoming';
    } else if (isFuture) {
      label = 'Upcoming';
      className = 'chip-upcoming chip-font-upcoming';
    } else if (eventItem.isComplete && hasNoExers) {
      label = 'Complete';
      className = 'chip-complete chip-font-complete';
    } else if (eventItem.isComplete) {
      label = 'Complete';
      className = 'chip-complete chip-font-complete';
    } else {
      label = 'Incomplete';
      className = 'chip-incomplete chip-font-incomplete';
    }

    return (
      <Chip
        label={label}
        size="small"
        className={className}
      />
    )
  }

  const label = eventRecord && (
    <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
      <Box>
        <Typography
          variant="body2"
          className={classes.title}
        >
          {eventRecord.name}
        </Typography>
        <Typography
          variant="body2"
          className={classes.sub}
        >
          {format(parseISO(eventRecord.date), 'MMM dd, yyyy h:mm aaa')}
        </Typography>
        {eventRecord.location &&
          <Typography
            variant="body2"
            className={classes.sub}
          >
            {eventRecord.location.locationName}
          </Typography>}
      </Box>
      <Box>
        {chip(eventRecord)}
      </Box>
    </Box>
  );

  return (
    <>
      {eventRecord &&
        <>
          <DrawerMenuItem
            id={`event-${eventRecord.id}`}
            iconName='event'
            label={label}
            to={to}
            isActive={isActive}
            hideChevron={hideChevron}
          />
        </>}
    </>
  );
}